// client/src/utils/quotationFrozen.ts
/**
 * The quotation statuses that mean "this quotation will not change again" (D45.2): a frozen
 * quotation refuses edits and match confirmations, and is harvested into the catalogue.
 *
 * `rejected` is in the list by owner instruction (a rejected quotation's costs are still real
 * costs; see quotationCatalogueHarvest.service for what bounds the risk).
 *
 * MIRRORED FILE: client/src/utils/quotationFrozen.ts is a line-for-line twin. Change one, change
 * both; `mirroredUtilParity.test.js` checks. The server's harvest service imports from here.
 */
export const FROZEN_STATUSES: readonly string[] = Object.freeze(['finalized', 'sent', 'rejected']);

/** Does this status mean the quotation is settled? */
export function isFrozenStatus(status: unknown): boolean {
  return FROZEN_STATUSES.includes(String(status == null ? '' : status).trim());
}
